var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-map",style:({
    width: _vm.width,
    height: _vm.height,
  }),attrs:{"id":_vm.id}},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":`${_vm.id}--map`}}),(_vm.searchbox)?_c('Search',{staticClass:"map-search",attrs:{"width":_vm.width > 350 ? '300px' : `${_vm.width - 0}px`,"value":_vm.searchVal,"placeholder":"Cari...","valueAsObject":true,"textKey":"display_name","dbref":{ method: 'get', url: this.parseUrl, parseData: this.parseData }},on:{"update:value":function($event){_vm.searchVal=$event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }